var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;fill-opacity:0;}.cls-2{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_24_Cancel",
    "data-name": "24_Cancel"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    className: "cls-1",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.83,9.17c-1.14.87-4.54,4.66-5.66,5.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.83,14.83c-1.24-1.32-4.69-4.51-5.66-5.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.44,2h1.2C21,2,22,3,22,11.44v1.18C22,21,21,22,12.62,22H11.44C3,22,2,20.58,2,12.63V11.44C2,3.43,3,2,11.44,2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.6f3a3aafe1b204a23a4a707445c03e64.svg";
export { ForwardRef as ReactComponent };